import { createContext, useContext } from "react";
import { useLocalStorageState } from "src/utils/hook/base/baseserviceindex";

export const AppThemeContext = createContext();

const AppThemeContextProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useLocalStorageState(false, "darkTheme");

  const toggleDarkMode = () => {
    setIsDarkMode((isDark) => !isDark);
  };

  return <AppThemeContext.Provider value={{ toggleDarkMode, isDarkMode }}>{children}</AppThemeContext.Provider>;
};

function useDarkMode() {
  const context = useContext(AppThemeContext);
  if (context === undefined) throw new Error("context not work");
  return context;
}

export { AppThemeContextProvider, useDarkMode };
